// src/lib/localDate.js
// STATUS: active | UPDATED: 2026-09-23
// LOG:
//   2026-09-23  New. Third copy of the same five lines was about to be written,
//               so they got a home instead.
//
// DATES ARE BUILT FROM LOCAL PARTS. NEVER toISOString.
//
// This is the whole file's reason to exist, and it is a real bug rather than a
// preference. A manager in Arkansas saving at 8pm is already tomorrow in UTC,
// so `new Date().toISOString().slice(0, 10)` files the day a day late. A store
// reporting September at 8pm on the 30th files the month under October.
//
// Both had been written correctly in two places by 2026-09-23, with the same
// comment above each, which is how a third copy gets written slightly wrong.
//
// Every function here is pure and takes its "now" as an argument so it can be
// tested at a fixed instant.

// 2026-09-23
export function dayKey(d = new Date()) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

// 2026-09-01, the convention `period_month` stores.
export function monthKey(d = new Date()) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}-01`
}

// Through the Date constructor, which normalises out of range values on its
// own: day 0 is the last of the previous month and month 12 is January of the
// next year. Doing this arithmetic by hand is where the December bugs live.
export function addDays(key, n) {
  const [y, m, d] = key.split('-').map(Number)
  return dayKey(new Date(y, m - 1, d + n))
}

export function shiftMonth(key, by) {
  const [y, m] = key.split('-').map(Number)
  return monthKey(new Date(y, m - 1 + by, 1))
}

// Midnight local, for comparing a stored date string against today without the
// time of day getting involved.
export function startOfDay(d = new Date()) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

export function parseDay(key) {
  const [y, m, d] = String(key).split('-').map(Number)
  return new Date(y, m - 1, d)
}
